import {Injectable} from '@angular/core';
import {UserSettingsStore} from './user-settings.store';
import {select} from "@ngneat/elf";

@Injectable({ providedIn: 'root' })
export class UserSettingsQuery {

  currentSettings$ = this.store.data.pipe(select(localstore => localstore));

  constructor(protected store: UserSettingsStore) {
  }

}
